var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Outer Lines",
    id: "Outer_Lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,40a1,1,0,0,0,1-1V38a1,1,0,0,0-2,0v1A1,1,0,0,0,51,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,40H48a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,42a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V43A1,1,0,0,0,51,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,41a1,1,0,0,0-1-1H53a1,1,0,0,0,0,2h1A1,1,0,0,0,55,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,40H32V38a1,1,0,0,0-2,0v2H28a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V42h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,44H38a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,44H43a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.981,40.908A9.153,9.153,0,0,0,51.073,32H51a8.924,8.924,0,0,0-6.7,3h-6.59A8.894,8.894,0,0,0,34,32.535V4a4,4,0,0,0-4-4H4A4,4,0,0,0,0,4V46a4,4,0,0,0,4,4H22v4.59a5.41,5.41,0,0,0,10.134,2.637l3.738-6.713A1,1,0,0,1,36.745,50h8.51a1,1,0,0,1,.873.514l3.74,6.715A5.409,5.409,0,0,0,60,54.59v-13.3c0-.056-.007-.11-.008-.165S60,41.041,60,41A.937.937,0,0,0,59.981,40.908ZM30.927,32A9.123,9.123,0,0,0,22.1,40H2V10H32V32.069A9.338,9.338,0,0,0,30.927,32ZM4,2H30a2,2,0,0,1,2,2V8H2V4A2,2,0,0,1,4,2ZM4,48a2,2,0,0,1-2-2V42H22v6Zm54,6.59a3.41,3.41,0,0,1-6.386,1.664l-3.738-6.713A3,3,0,0,0,45.255,48h-8.51a3,3,0,0,0-2.621,1.541l-3.736,6.71A3.409,3.409,0,0,1,24,54.59V46.634A8.969,8.969,0,0,0,26.5,48.8a1,1,0,0,0,1-1.731,7.023,7.023,0,0,1-3.493-5.942A7.159,7.159,0,0,1,30.942,34H31a7.046,7.046,0,0,1,6.779,5.25,1,1,0,0,0,.968.75A1.033,1.033,0,0,0,39,39.969a1,1,0,0,0,.719-1.219A8.948,8.948,0,0,0,39.051,37h3.9a8.948,8.948,0,0,0-.666,1.75A1,1,0,0,0,43,39.969a1.033,1.033,0,0,0,.251.031,1,1,0,0,0,.968-.75A7.046,7.046,0,0,1,51,34h.058a7.157,7.157,0,0,1,6.934,7.121A7.021,7.021,0,0,1,54.5,47.064a1,1,0,1,0,1,1.731A8.969,8.969,0,0,0,58,46.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6h1a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6h3a1,1,0,0,0,0-2H13a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,44H16a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.707,17.293a1,1,0,0,0-1.414,0l-6,6a1,1,0,0,0,0,1.414l6,6a1,1,0,0,0,1.414-1.414L6.414,24l5.293-5.293A1,1,0,0,0,11.707,17.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.707,17.293a1,1,0,0,0-1.414,1.414L27.586,24l-5.293,5.293a1,1,0,1,0,1.414,1.414l6-6a1,1,0,0,0,0-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.316,17.051a1,1,0,0,0-1.264.633l-4,12a1,1,0,1,0,1.9.632l4-12A1,1,0,0,0,19.316,17.051Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameDevelopment);
export default __webpack_public_path__ + "static/media/Game Development.9558becc269bb003d7f83deb73b16d45.svg";
export { ForwardRef as ReactComponent };